export const translations = {
  type: {
    pt: 'Tipo',
    en: 'Type',
    es: 'Tipo',
    de: 'Typ',
  },
  value: {
    pt: 'Valor',
    en: 'Value',
    es: 'Valor',
    de: 'Wert',
  },
  cityType: {
    pt: 'CIDADE',
    en: 'CITY',
    es: 'CIUDAD',
    de: 'STADT',
  },
  coordinatesType: {
    pt: 'LAT/LNG',
    en: 'LAT/LNG',
    es: 'LAT/LNG',
    de: 'LAT/LNG',
  },
  stopAlreadyExistsMessage: {
    pt: 'Já existe uma parada com as coordenadas informadas',
    en: 'A stop with the given coordinates already exists',
    es: 'Ya existe una parada con las coordenadas proporcionadas',
    de: 'Ein Halt mit den angegebenen Koordinaten existiert bereits',
  },
  removeConfirmationMessage: {
    pt: 'Remover a parada {{locationName}}?',
    en: 'Remove the stop {{locationName}}?',
    es: '¿Eliminar la parada {{locationName}}?',
    de: 'Die Haltestelle {{locationName}} entfernen?',
  },
}